import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const Postamats = React.memo(({ postamats }) => {
    const icon = divIcon({ className: "map-icon--postamats", iconSize: [22, 22] });
    return postamats.map((el, index) => <Postamat key={index} icon={icon} item={el} />);
});

const Postamat = (props) => {
    const {
        item: { name, geozone, brand, code, schedule },
        icon,
    } = props;
    if (!geozone?.location?.coordinates) {
        return null;
    }
    return (
        <Marker position={[...geozone.location.coordinates].reverse()} icon={icon}>
            <Tooltip
                className="map__tooltip-postamats leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div>
                    <h6>{name}</h6>
                    <div className="text-muted mb-2">{geozone.address}</div>
                    <div>
                        <b>Бренд:</b> {brand}
                    </div>
                    <div>
                        <b>Код:</b> {code}
                    </div>
                    <div>
                        <b>График работы:</b> {schedule}
                    </div>
                </div>
            </Tooltip>
        </Marker>
    );
};

const MemoizedPostamats = (props) => <Postamats {...props} />;

export default MemoizedPostamats;
